export default "__VITE_ASSET__CziS4ZD5__"